/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Getting_ProxyInputs */

const en_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting proxy information...`)
};

const fr_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperation des informations du proxy...`)
};

const de_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Informationen abrufen...`)
};

const it_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottenimento delle informazioni sul proxy...`)
};

const ru_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение информации о прокси-сервере...`)
};

const es_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo información del proxy...`)
};

const zh_cn2_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在获取代理信息……`)
};

const ja_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシ情報を取得しています...`)
};

const hi_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी जानकारी प्राप्त की जा रही है...`)
};

const pt_pt2_iconik_proxy_status_getting_proxy = /** @type {(inputs: Iconik_Proxy_Status_Getting_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtendo informações de proxy...`)
};

/**
* | output |
* | --- |
* | "Getting proxy information..." |
*
* @param {Iconik_Proxy_Status_Getting_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_getting_proxy = /** @type {((inputs?: Iconik_Proxy_Status_Getting_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Getting_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "de") return de_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "it") return it_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "ru") return ru_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "es") return es_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "ja") return ja_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "hi") return hi_iconik_proxy_status_getting_proxy(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_status_getting_proxy(inputs)
	return en_iconik_proxy_status_getting_proxy(inputs)
});